module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/dir_on-38a752dc5c7e4e39f29cc849fd4f2977.gif";